import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * Broadcasts that a change order was created. The event is named for what happened, not for any
 * one subscriber's reaction to it — each subscriber decides what it means for its own data.
 *
 * Payload-free and unfiltered by design. `app-compensation-tabs` is mounted in exactly one place
 * (the viewer's project cards for the single job on screen), so "every mounted card" and "every
 * project on this job" are the same set. The ids needed to filter never reach the emitter anyway:
 * the change order modal closes with `activeModal.close()` and no value. And filtering to only the
 * projects this change order touched would be wrong — JobGross and JobNet are job-wide, so the job
 * PAR ratio in every sibling project's commission context moves too.
 *
 * See docs/superpowers/specs/2026-08-10-refresh-commissions-on-change-order-design.md.
 */
@Injectable({ providedIn: 'root' })
export class ChangeOrderEventsService {
  private readonly addedSubject = new Subject<void>();

  readonly changeOrderAdded$: Observable<void> = this.addedSubject.asObservable();

  notifyChangeOrderAdded(): void {
    this.addedSubject.next();
  }
}
